<template>
    <div>
        
        <v-container>
            <v-card class="mx-auto">
                <v-toolbar flat color="secondary">
                    <v-toolbar-title>{{edit === true ? 'Edit Vendor':'Tambah Vendor'}}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-form
                        ref="form"
                        @keup.enter="event.preventDefault()"
                        lazy-validation>
                        <span class="title">Informasi Umum</span>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                :counter="50"
                                label="Nama Vendor"
                                v-focus
                                v-model="nama_vendor"
                                outlined
                                ></v-text-field>
                                            
                                <v-text-field
                                :counter="250"
                                label="Deskripsi"
                                outlined
                                v-model="deskripsi"
                                ></v-text-field>

                                <v-text-field
                                :counter="50"
                                label="Email"
                                outlined
                                v-model="email_vendor"
                                ></v-text-field>

                                <v-text-field   
                                :counter="50"
                                label="Telephone"
                                outlined
                                v-model="telephone_vendor"
                                ></v-text-field>

                                <v-text-field
                                :counter="50"
                                label="Fax"
                                outlined
                                v-model="fax_vendor"
                                ></v-text-field>

                                <v-select 
                                label="Active"
                                :items="select_active"
                                outlined
                                v-model="active_vendor"
                                ></v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-row dense>
                                    <v-col cols="8">
                                        <v-text-field
                                        :counter="50"
                                        label="NPWP"
                                        v-model="npwp"
                                        outlined
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="4">
                                        <v-file-input
                                        label="Image"
                                        v-model="img_npwp"
                                        accept="image/jpeg,image/jpg"
                                        prepend-icon="mdi-camera"
                                        outlined
                                    ></v-file-input>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="8">
                                        <v-text-field
                                        :counter="50"
                                        label="SIUP"
                                        v-model="siup"
                                        outlined 
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-file-input
                                        v-model="img_siup"
                                        label="Image"
                                        accept="image/jpeg,image/jpg"
                                        prepend-icon="mdi-camera"
                                        outlined
                                    ></v-file-input>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="8">
                                        <v-text-field
                                        :counter="50"
                                        label="TDP"
                                        v-model="tdp"
                                        outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-file-input
                                            label="Image"
                                            v-model="img_tdp"
                                            accept="image/jpeg,image/jpg"
                                            prepend-icon="mdi-camera"
                                            outlined
                                        ></v-file-input>
                                    </v-col>
                                </v-row>
                                <v-textarea
                                :counter="2000"
                                v-model="tnc"
                                label="Terms and Conditions"
                                outlined
                                ></v-textarea>
                            </v-col>
                        </v-row>
                        
                        <v-row v-if="this.$route.name=='vendor.edit'">
                            <v-col>
                                <alamat :parse="{id_vendor:this.$route.params.id}"/>
                            </v-col>
                        </v-row>
                        
                        <div v-else>
                            <span class="title">Alamat Vendor</span>
                            <alamatForm @change_value="getAlamatData"/>
                        </div>

                        <v-row v-if="this.$route.name=='vendor.edit'">
                            <v-col>
                                <pic/>
                            </v-col>
                        </v-row>
                        <div v-else>
                            <span class="title">PIC Vendor</span>
                            <picForm @change_value="getPicData"/>
                        </div>

                        <v-row>
                            <v-col>
                                <v-card-actions>
                                    <v-btn @click="btnBack"
                                    color="grey lighten-5" type="button"><v-icon left>{{icon.back}}</v-icon>Back</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn 
                                    :disabled="loading"
                                    color="primary" type="button"
                                    @click.native="storeVendor()" class="float-right"><v-icon left>{{icon.save}}</v-icon>Simpan</v-btn>
                                </v-card-actions>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-container>
        <!-- <v-container >
        </v-container>     -->
    </div>
</template>

<script>
/* eslint-disable */
    import rules from "@/plugins/validation_rules.js";
    import alamat from "@/components/vendor/alamat/Index.vue";
    import alamatForm from "@/components/vendor/alamat/Form.vue";
    import pic from "@/components/vendor/pic/Index.vue";
    import picForm from "@/components/vendor/pic/Form.vue";
    import formHelper from "@/plugins/form.js"

    let context;
    export default{
        name:"vendor.form",
        components:{
            alamat,
            alamatForm,
            pic,
            picForm
        },
        data:()=>{
            return{
                edit:false,
                loading:false,
                show:false,
                rules:rules,
                icon:{
                    save:"mdi-check-bold",
                    back:"mdi-arrow-left"
                },
                select_active:[
                    {text:"Active",value:1},
                    {text:"Disable",value:0}
                ],
                nama_vendor:"",
                deskripsi:"",
                email_vendor:"",
                telephone_vendor:"",
                fax_vendor:"",
                active_vendor:1,
                npwp:"",
                img_npwp:null,
                siup:"",
                img_siup:null,
                tdp:"",
                img_tdp:null,
                tnc:"",
                nama_pic:"",
                job_title:"",
                email_pic:"",
                telephone_pic:"",
                active_pic:1,
                nama_alamat:"",
                alamat:"",
                coord:"",
                country:"",
                province:"",
                city:"",
                district:"",
                postcode:"",
                telephone_alamat:""
            }
        },
        methods:{
            btnBack () {
                context.$router.go(-1);
            },

            getPicData:(data)=>{
                context.nama_pic=data.nama_pic
                context.job_title=data.job_title
                context.email_pic=data.email_pic
                context.telephone_pic=data.telephone_pic
                context.active_pic=data.active_pic
            },
            getAlamatData:(data)=>{
                context.nama_alamat=data.nama_alamat
                context.alamat=data.alamat
                context.city=data.city
                context.coord=data.coord
                context.country=data.country
                context.province=data.province
                context.district=data.district
                context.postcode=data.postcode
                context.telephone_alamat=data.telephone_alamat
            },
            storeVendor:async ()=>{
                if(context.$refs.form.validate()){
                    context.loading=true;
                    let formData = new FormData();
                    formData.append("nama_vendor",context.nama_vendor);
                    formData.append("deskripsi",context.deskripsi);
                    formData.append("email_vendor",context.email_vendor);
                    formData.append("telephone_vendor",context.telephone_vendor);
                    formData.append("fax_vendor",context.fax_vendor);
                    formData.append("npwp",context.npwp);
                    formData.append("img_npwp",context.img_npwp);
                    formData.append("tdp",context.tdp);
                    formData.append("img_tdp",context.img_tdp);
                    formData.append("siup",context.siup);
                    formData.append('img_siup',context.img_siup);
                    formData.append("tnc",context.tnc)
                    formData.append("active_vendor",context.active_vendor);
                    
                    if(!context.edit){
                        formData.append("nama_alamat",context.nama_alamat);
                        formData.append("alamat",context.alamat);
                        formData.append("coord",JSON.stringify(context.coord));
                        formData.append("country",context.country);
                        formData.append("province",context.province);
                        formData.append("city",context.city);
                        formData.append("district",context.district);
                        formData.append("postcode",context.postcode);
                        formData.append("telephone_alamat",context.telephone_alamat);
                        formData.append("nama_pic",context.nama_pic);
                        formData.append("job_title",context.job_title);
                        formData.append("email_pic",context.email_pic);
                        formData.append("telephone_pic",context.telephone_pic);
                        formData.append("active_pic",context.active_pic);
                        await context.$http
                        .post('vendor/store',formData)
                        .then(response=>{
                            // console.log(response)
                            if(response.status===200){
                                context.$notify({
                                    group:"success",
                                    title:"Success Notification",
                                    text:"Berhasil menambahkan "+context.nama_vendor+" ke database"
                                })
                                context.btnBack();
                            }
                        })
                        .catch(err=>{
                            context.$notify({
                                    group:"error",
                                    title:"Error Notification",
                                    text:"Terjadi kesalahan pada client"
                            })
                            context.loading=false;
                        });

                    }else{
                        formData.append("id",context.$route.params.id);
                        await context.$http
                        .post('vendor/update',formData)
                        .then(response=>{
                            if(response.status===200){
                                context.$notify({
                                    group:"success",
                                    title:"Success Notification",
                                    text:"Berhasil merubah "+context.nama_vendor
                                })
                                // context.btnBack();
                            }
                        })
                        .catch(err=>{
                            context.$notify({
                                    group:"error",
                                    title:"Error Notification",
                                    text:"Terjadi kesalahan pada client"
                            })
                            context.loading=false;

                        });
                    }          
                    context.loading=false;
                }
            },

        },

        async mounted(){
            context=this;
            if(context.$route.name==="vendor.edit"){
                context.edit=true;
                await context.$http
                .get('vendor/get?id='+context.$route.params.id)
                .then(response=>{
                    let vendor=response.data.data;
                    if(vendor!=null){
                        context.nama_vendor=vendor.name;
                        context.deskripsi=vendor.description;
                        context.active_vendor=vendor.active;
                        context.email_vendor=vendor.email;
                        context.telephone_vendor=vendor.phone;
                        context.fax_vendor=vendor.fax;

                        context.npwp=vendor.npwp;
                        context.siup=vendor.siup;
                        context.tdp=vendor.tdp;
                        context.tnc=vendor.terms_conditions;     
                    }else{
                        context.btnBack();
                    }
                })
                .catch(err=>{

                })
            }
        }
    }
</script>